import { useTranslation } from 'react-i18next';

const NewPatientRejection = function (props: { healthCarePartyPhoneNumber?: string; healthCarePartyName: string }) {
  const { t } = useTranslation();
  return <div dangerouslySetInnerHTML={{ __html: t('FLOW.NEW_PATIENT_REJECTION.TEXT', props) }} />;
};
export default NewPatientRejection;
